
export const initialState = {
    auth: {
        user: null,
        token: null
    },
    open: {
        batteryId: null,        // an id to find the battery in myBatteries.batteries or in connection.bleAvailable
    },
    connection: {
        bleAvailable: [],
        bleSearching: false,
        bleError: null,
    },
    myBatteries: {
        batteries: [],          // a list of batteries downloaded
        lastUpdated: null,
    },
    allBatteries : {
        batteries: [],          // a list of all batteries
        lastUpdated: null,
    },
    batteryById : {
        battery: null,
        lastUpdated: null,
    },
    history: {
        states: [],
        page: 0,
        lastUpdated: null,
        cellStates: [],
        cellPage: 0,
    },
    allUsers : {
        users: [],
        lastUpdated: null,
    },
    userById : {
        user: null,
        lastUpdated: null,
    }
}